import React from "react";
import Axios from 'axios'
import Slider from "react-slick";
import moment from 'moment';
import { Link } from 'react-router-dom';

export class DetalhamentoPedido extends React.Component {
  constructor(props) {
super(props);
    this.state = {
      user: JSON.parse(this.props.user) ,
      cartelas: null,
      pedidos: [JSON.parse(this.props.pedido)],
      numeros : []
    }
    this.obterNumerosSorteados()
  }
    async obterNumerosSorteados(e){
      try {
          var axiosInstance = new Axios.create({
            baseURL: window.localStorage.getItem("apiUrl")
          });
          const response = await axiosInstance.get("parametros/obter-numeros-sorteados", {});
          this.setState({numeros : response.data})
        } catch (err) {
          console.log(err);
        }
      }

      conferirColorir(cartelaNumero){
          if(this.state.numeros.length > 0){
          return this.state.numeros.some(numero => numero == cartelaNumero)
          }
          return false
      }


      formatDate(data) {
      return moment(data).add(0,'days').format('DD-MM-YYYY')
      }
  
  render() {
    var settings = {
      dots: false,
      infinite: false,
      speed: 1,
      slidesToShow: 1,
      slidesToScroll: 1
    };
    return (
            <div class="content">
              <div class="container-fluid">
                <div class="bg-dark">
                <h5 class="text-center text-warning">Esse pedido só sera validado quando for repassado a BANCA os valores pendentes!</h5>
                </div>
                {this.state.pedidos != null ? this.state.pedidos.map(pedido => {
                  return <Slider class={"p-5 w-100"} {...settings}>
                   
                  {pedido.cartelas?
                     pedido.cartelas.map((cartela, index) => {
                        return (
                          
                          <button
                            class="superContainer p-2"
                            onClick={this.selecionar}
                            name={index}
                            key={index}
                          >
                            <div
                              id={"item-" + index}
                              class="card text-white bg-dark mb-3 shadow"
                            >
                              <div class="bg-dark card-header ">
                                <div class="container ">
                                <div class="row">
                                    <div class="col">
                                      <div class="row">
                                        <span class="font-weight-bold">
                                          código : <Link class="text-danger">{cartela.codigo}</Link>
                                        </span>
                                      </div>
                                      <div class="row">
                                        <span class="font-weight-bold text-warning">
                                          Data do sorteio : <Link class="text-light">{this.formatDate(cartela.data)}</Link>
                                        </span>
                                      </div>
                                    </div>
                                    <div class="col">
                                      <div class="row justify-content-end">
                                        <span class="font-weight-bold">
                                          lote: <Link class="text-danger">  {pedido.loteId? pedido.loteId.codigo : "0"}</Link>
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="row justify-content-center font-weight-bold">
                                      {pedido.recebido?
                                        <span class="text-success">
                                            Pagamento recebido
                                        </span>
                                        :
                                        <span class="text-warning">
                                            Aguardando pagamento
                                        </span>}
                                  </div>
                                  <div class="row justify-content-center font-weight-bold">
                                      {pedido.validado?
                                        <span class="text-success">
                                            Validado pela banca
                                        </span>
                                        :
                                        <span class="text-warning">
                                            {/* Aguardando validação */}
                                        </span>}
                                  </div>
                                </div>
                              </div>
                              <div class="bg-dark card-body justify-content-center ajustar">
                                <div
                                  class="bg-light rounded"
                                  style={{ width: "17.8em", height: "10em" }}
                                >
                                {cartela.numeros? 
                                
                                <div class="container text-dark tracado">
                                <div class="row">
                                  <div class={this.conferirColorir(cartela.numeros[0])? "text-light bg-danger col" : 'col'}>
                                    <span >{cartela.numeros[0]}</span>
                                  </div>
                                  <div class={this.conferirColorir(cartela.numeros[1])? "text-light bg-danger col" : 'col'}>
                                    <span>{cartela.numeros[1]}</span>
                                  </div>
                                  <div class={this.conferirColorir(cartela.numeros[2])? "text-light bg-danger col" : 'col'}>
                                    <span>{cartela.numeros[2]}</span>
                                  </div>
                                  <div class={this.conferirColorir(cartela.numeros[3])? "text-light bg-danger col" : 'col'}>
                                    <span>{cartela.numeros[3]}</span>
                                  </div>
                                  <div class={this.conferirColorir(cartela.numeros[4])? "text-light bg-danger col" : 'col'}>
                                    <span>{cartela.numeros[4]}</span>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class={this.conferirColorir(cartela.numeros[5])? "text-light bg-danger col" : 'col'}>
                                    <span>{cartela.numeros[5]}</span>
                                  </div>
                                  <div class={this.conferirColorir(cartela.numeros[6])? "text-light bg-danger col" : 'col'}>
                                    <span>{cartela.numeros[6]}</span>
                                  </div>
                                  <div class={this.conferirColorir(cartela.numeros[7])? "text-light bg-danger col" : 'col'}>
                                    <span>{cartela.numeros[7]}</span>
                                  </div>
                                  <div class={this.conferirColorir(cartela.numeros[8])? "text-light bg-danger col" : 'col'}>
                                    <span>{cartela.numeros[8]}</span>
                                  </div>
                                  <div class={this.conferirColorir(cartela.numeros[9])? "text-light bg-danger col" : 'col'}>
                                    <span>{cartela.numeros[9]}</span>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class={this.conferirColorir(cartela.numeros[10])? "text-light bg-danger col" : 'col'}>
                                    <span>{cartela.numeros[10]}</span>
                                  </div>
                                  <div class={this.conferirColorir(cartela.numeros[11])? "text-light bg-danger col" : 'col'}>
                                    <span>{cartela.numeros[11]}</span>
                                  </div>
                                  <div class={this.conferirColorir(cartela.numeros[12])? "text-light bg-danger col" : 'col'}>
                                    <span>{cartela.numeros[12]}</span>
                                  </div>
                                  <div class={this.conferirColorir(cartela.numeros[13])? "text-light bg-danger col" : 'col'}>
                                    <span>{cartela.numeros[13]}</span>
                                  </div>
                                  <div class={this.conferirColorir(cartela.numeros[14])? "text-light bg-danger col" : 'col'}>
                                    <span>{cartela.numeros[14]}</span>
                                  </div>
                                </div>
                              </div>
                            
                            : ""}
                                </div>
                              </div>
                            </div>
                            <span
                              id={"sel-tit-" + index}
                              class="collapse font-weight-bold text-success"
                            >
                              Selecionado
                            </span>
                          </button>
                 

                        );
                      })
                    :  ""}
                </Slider>

                }) : ""}
                            </div>
              </div>
    );
  }
}

export default DetalhamentoPedido;
